import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { NAV_FUNCTIONS } from '../../lib/navFunctions';

// Rotte extra non presenti nel catalogo funzioni (per orientamento nel topbar).
const EXTRA_ROUTES = [
  { path: '/funzioni', tKey: 'nav.funzioni', cat: 'management' },
];

const resolve = (pathname) => {
  const all = [...NAV_FUNCTIONS, ...EXTRA_ROUTES];
  // Match più specifico prima (path più lungo).
  const sorted = [...all].sort((a, b) => b.path.length - a.path.length);
  return sorted.find((f) => pathname === f.path || pathname.startsWith(f.path + '/')) || null;
};

// Blocco titolo pagina + sottotitolo (colore muted, di fianco al titolo).
export const PageTitle = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const fn = resolve(pathname);
  if (!fn) return <div className="min-w-0" />;

  const subtitle = fn.subKey ? t(fn.subKey) : '';
  return (
    <div className="flex min-w-0 flex-col justify-center leading-tight">
      {/* La categoria (Operazioni/Gestione/Analisi) resta solo nella tendina laterale,
          non viene più mostrata qui nella barra in alto. */}
      <div className="flex items-baseline gap-2 min-w-0">
        <h1 className="shrink-0 text-base sm:text-lg font-display font-extrabold tracking-tight" data-testid="topbar-page-title">
          {t(fn.tKey)}
        </h1>
        {subtitle && (
          <span className="hidden md:block truncate text-sm text-muted-foreground" data-testid="topbar-page-subtitle">
            {subtitle}
          </span>
        )}
      </div>
    </div>
  );
};
